// @flow
import {
	ProductListSlider,
	EshopPhotogallery,
	EshopModel3D,
	EshopImageMagnify,
	EshopGalleryPopup,
	EshopOrderForm,
} from 'fg-frontend';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'ProductListSlider':
			return ProductListSlider;
		case 'EshopPhotogallery':
			return EshopPhotogallery;
		case 'EshopModel3D':
			return EshopModel3D;
		case 'EshopImageMagnify':
			return EshopImageMagnify;
		case 'EshopGalleryPopup':
			return EshopGalleryPopup;
		case 'EshopOrderForm':
			return EshopOrderForm;
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js